export const DEFAULT_EMOJI_CDN = '//img.t.sinajs.cn/t4/appstyle/expression/ext/normal/'

export const DB_NAME = 'Comment';

export const defaultConfig = {
  lang: 'zh-CN',
  langMode: null,
  appId: '',
  appKey: '',
  clazzName: 'Comment',
  meta: ['nick','mail','link'],
  path: location.pathname,
  placeholder: 'Just Go Go',
  pageSize: 10,
  recordIP: !0,
  serverURLs: '',
  visitor: !1,
  mathJax: !1,
  emojiCDN: '',
  emojiMaps: void 0,
  enableQQ: !1,
  requiredFields:[]
};


export const defaultMeta = ['nick', 'mail', 'link']

export const QQCacheKey = '_v_Cache_Q'

export const MetaCacheKey = '_v_Cache_Meta'

export const RandomStr = n => (Date.now()+Math.round(Math.random()*1000)).toString(32)

export const VERSION = '1.4.15'


